import React, { useState, useEffect } from 'react'
import { Panel, Row, Col, SelectPicker, Message, Placeholder, Table } from 'rsuite'
import TablePagination from 'rsuite/lib/Table/TablePagination'
import { getProjectTableView, getUserProfile } from '../../redux/actions/dashboard'
import { numberThousandSeparator } from '../../utils/formatterUtil'
import DashboradToggle from './DashboradToggle'

export default function ProjectTableView({ isSetting, isShow, onSettingChange, dashboradName }) {
  const { Column, HeaderCell, Cell, ColumnGroup } = Table
  const { Paragraph } = Placeholder
  const [isLoading, setIsLoading] = useState(false)
  const [isError, setIsError] = useState(false)
  const [errorMsg, setErrorMsg] = useState(false)
  const [isReLoading, setIsReLoading] = useState()

  const [pagesize, setPagesize] = useState(5)
  const [pagenumber, setPagenumber] = useState(1)
  const [budgetYear, setBudgetYear] = useState()

  const defaultLengthMenu = [
    { value: 5, label: 5 },
    { value: 10, label: 10 },
    { value: 15, label: 15 },
    { value: 20, label: 20 },
  ]

  const [schema, setSchema] = useState()

  useEffect(() => {
    handelGetSchemaDashboard()
  }, [])

  const handelGetSchemaDashboard = async () => {
    setIsLoading(true)
    setIsError(false)
    try {
      let response
      if (isSetting) {
        response = mock

        let datas = []

        for (var i = 0; i < 10; i++) {
          datas.push({
            id: 'id' + i,
            budgetPlanCode: '010111' + i,
            budget: i % 2 ? (i + 10) * 1000000 : (i + 10) * 2000000,
            inPipe: i % 2 ? (i + 3) * 1000000 : (i + 1) * 2000000,
            approve: i % 2 ? (i + 2) * 1000000 : (i + 2) * 2000000,
            projectPercent: i % 2 ? 50 : 30,
            pr: i % 2 ? (i + 4) * 1000000 : (i + 3) * 2000000,
            po: i % 2 ? (i + 1) * 1000000 : (i + 4) * 2000000,
            procurementPercent: i % 2 ? 50 : 70,
          })
        }
        response.totalSize = 10
        response.data = datas
      } else {
        response = await getProjectTableView(null, 5, 1)
      }

      setBudgetYear(response?.budgetYear?.value)
      setSchema(response)
    } catch (e) {
      setIsError(true)
      setErrorMsg(e.message)
    }
    setIsLoading(false)
  }

  const onReload = async (year, pagesize, pagenumber) => {
    setIsReLoading(true)
    setIsError(false)
    try {
      const response = await getProjectTableView(year, pagesize, pagenumber)

      setSchema(response)
    } catch (e) {
      setIsError(true)
      setErrorMsg(e.message)
    }
    setIsReLoading(false)
  }

  const handleChangeLength = (dataKey) => {
    setPagenumber(1)
    setPagesize(dataKey)
    onReload(budgetYear, dataKey, 1)
  }

  const handleChangePage = (dataKey) => {
    setPagenumber(dataKey)
    onReload(budgetYear, pagesize, dataKey)
  }

  const BudgetCell = ({ rowData, dataKey, ...props }) => (
    <Cell {...props}>{numberThousandSeparator(rowData[dataKey])}</Cell>
  )

  if (!schema || isLoading) {
    return (
      <Panel shaded bordered defaultExpanded>
        <Paragraph rows={10}></Paragraph>
      </Panel>
    )
  }

  return (
    <>
      {isSetting && (
        <DashboradToggle
          onChange={onSettingChange}
          dashboradName={dashboradName}
          checked={isShow}
        />
      )}

      <Panel bordered shaded style={{ marginTop: 10 }}>
        {schema.budgetYear && (
          <Row style={{ marginBottom: 15 }}>
            {schema.budgetYear.label}
            <SelectPicker
              data={schema.budgetYear.options}
              defaultValue={schema.budgetYear.value}
              style={{ marginLeft: 10, marginTop: '3px' }}
              searchable={false}
              placeholder="เลือก"
              onChange={(value) => {
                setBudgetYear(value)
                onReload(value, pagesize, pagenumber)
              }}
            />
          </Row>
        )}

        <Row style={{ marginBottom: 15 }}>
          <Col xs={24} sm={24} md={24} lg={24}>
            <Table
              rowKey="id"
              height={400}
              headerHeight={70}
              autoHeight={schema.data?.length <= 5}
              wordWrap={true}
              data={schema.data || []}
              loading={isReLoading}
              // cellBordered
            >
              <ColumnGroup header="แผนงบประมาณ" align="center">
                <Column width={180}>
                  <HeaderCell
                    align="center"
                    // style={{ border: '1px', borderStyle: 'solid', borderColor: 'red' }}
                  >
                    รหัสแผนงบประมาณ
                  </HeaderCell>
                  <Cell dataKey="budgetPlanCode" />
                </Column>
                <Column minWidth={150} width={150} flexGrow={1}>
                  <HeaderCell>ล้านบาท</HeaderCell>
                  <BudgetCell dataKey="budget" />
                </Column>
              </ColumnGroup>

              <ColumnGroup header="โครงการ" align="center">
                <Column width={160}>
                  <HeaderCell>ในท่อ</HeaderCell>
                  <BudgetCell dataKey="inPipe" />
                </Column>
                <Column width={160}>
                  <HeaderCell>อนุมัติ</HeaderCell>
                  <BudgetCell dataKey="approve" />
                </Column>
                <Column width={100}>
                  <HeaderCell>%</HeaderCell>
                  {/* <Cell dataKey="projectPercent" /> */}
                  <Cell>
                    {(rowData) => {
                      return `${rowData.projectPercent}%`
                    }}
                  </Cell>
                </Column>
              </ColumnGroup>
              <ColumnGroup header="จัดจ้าง" align="center">
                <Column width={160}>
                  <HeaderCell>PR</HeaderCell>
                  <BudgetCell dataKey="pr" />
                </Column>
                <Column width={160}>
                  <HeaderCell>PO</HeaderCell>
                  <BudgetCell dataKey="po" />
                </Column>
                <Column width={100}>
                  <HeaderCell>%</HeaderCell>
                  {/* <Cell dataKey="procurementPercent" /> */}
                  <Cell>
                    {(rowData) => {
                      return `${rowData.procurementPercent}%`
                    }}
                  </Cell>
                </Column>
              </ColumnGroup>
            </Table>
            <TablePagination
              lengthMenu={defaultLengthMenu}
              activePage={pagenumber}
              renderLengthMenu={(lengthMenu) => {
                return (
                  <>
                    {lengthMenu}
                    {`รายการ/หน้า`}
                  </>
                )
              }}
              renderTotal={(total) => {
                return <>{` ทั้งหมด ${total} รายการ`}</>
              }}
              displayLength={pagesize}
              total={schema.totalSize}
              onChangePage={handleChangePage}
              onChangeLength={handleChangeLength}
            />
          </Col>
        </Row>
      </Panel>
    </>
  )
}

const mock = {
  budgetYear: {
    name: 'budgetYear',
    value: '2564',
    label: 'ปีงบประมาณ',
    options: [{ label: '2564', value: 2564 }],
  },
  totalSize: 10,
  data: [
    {
      id: '1',
      budgetPlanCode: '010111',
      budget: 94800000,
      inPipe: 200000,
      approve: 1000000,
      projectPercent: 50.1,
      pr: 3000000,
      po: 3000000,
      procurementPercent: 50,
    },
  ],
}
